import { Grid, GridProps } from '@mui/material';

const GridContainer = (props: GridProps) => <Grid container spacing={2} {...props} />;
export default GridContainer;
